import type { DmConversation } from '@/types/direct-message'
import { DmHeader } from './DmHeader'
import { DmMessageList } from './DmMessageList'
import { DmMessageInput } from './DmMessageInput'

interface DmConversationPanelProps {
  conversation: DmConversation | null
  currentUserId: string | undefined
  onClose?: () => void
  onLeft: () => void
}

export function DmConversationPanel({ conversation, currentUserId, onClose, onLeft }: DmConversationPanelProps) {
  if (!conversation) {
    return (
      <div className="flex-1 flex items-center justify-center text-sm text-gray-400 bg-gray-50">
        Konversation auswählen
      </div>
    )
  }
  return (
    <div className="flex-1 flex flex-col min-h-0 relative bg-gray-50">
      <DmHeader
        conversation={conversation}
        currentUserId={currentUserId}
        onClose={onClose}
        onLeft={onLeft}
      />
      <DmMessageList conversation={conversation} currentUserId={currentUserId} />
      <DmMessageInput conversationId={conversation.conversation_id} />
    </div>
  )
}
